// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  name: 'cuu-long-prod',
  version: 'Error: no tags found (local or remote).',
  production: false,
  bucketName: 'cuulong',
  databaseUrl: { supabase: 'https://tpvkubxwvmwrkrxpvxtn.supabase.co', middleware: '' },
  posCloud: {
    apiURL: 'https://cuulong.menucat.de/api',
  },
  editEnabled: 'true',
  defaultLanguage: 'de',
  databaseAnonKey: { supabase: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRwdmt1Ynh3dm13cmtyeHB2eHRuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzA5MTc4NDYsImV4cCI6MjA4NjQ5Mzg0Nn0.Y6pxu5yGD1AjlHzwMHdngvAk1gV_OWCiLIS0hLK2tHM', middleware: '' },
  sentryDSN: '',
  posthogKey: 'phc_m3dOImc0jDJ5IzfKERikqSr4Nshq8XFVWV6DJKgYzhu',
  posthogHost: 'https://eu.i.posthog.com',
  posthogProxyHost: 'https://t.unauorder.com',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
